
/**
 * @fileOverview ComplianceBanner load rules
 * @author a3xs8zz
 * @modified 7/21/2015
 **/

 (function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;


    define('kungfu/ComplianceBanner/ComplianceRules',['require', 'jquery', 'lib/Util'], function (require) {
        var $ = require('jquery'),
            util = require('lib/Util');

        $debug('**** Compliance Banner Load Rules Started **** ', 'compBanner'); //syntax: $debug(message, urlParam);

        var ComplianceRules = function(){
            this.settings = {};
            this.campaign = '';
            // Store campaign settings here
            this.campSettings = {
                'FUZE Health Care Compliance': {
                    'NAME': 'FUZE_HC',
                    'PATH': '/{loc}/Group%20A/Corporate%20Content/ComplianceBanners/Professionals_Compliance',
                    'CLOSE': false,
                    'REDIRECT': 'https://www.3m.com/',
                    'AUTHENTICATE': false,
                    'BLUR': true,
                    'LOCALES': {
                        'fr_FR': {
                            'REDIRECT': '/3M/fr_FR/notre-societe-fr/'
                        },
                        'es_MX': {
                            'PATH': '/es_MX/Group%20A/Corporate%20Content/ComplianceBanners/FUZE_HC',
							'REDIRECT': '/3M/es_MX/inicio/'
                        },
                        'ja_JP': {
                            'REDIRECT': 'https://www.mmm.co.jp/hc/general.html'
                        }
                    }
                },
                'Notification Popup': {
                    'NAME': 'Notification_Popup',
                    'PATH': '/{loc}/Group%20A/CORP_FUZEExp/PopupMessage_SiteArea/Popup_Message',
                    'CLOSE': false
                },
                'Health Care Compliance': {
                    'NAME': 'EMEA_HC',
                    'PATH':'/{loc}/Group%20B/HCB_Dental/Compliance-Popup_SiteArea/Popup_Content',
                    'CLOSE': false,
                    'REDIRECT': '/3M/en_US/select-location/',
                    'AUTHENTICATE': false,
                    'BLUR': true,
                    'LOCALES': {
                        'cs_CZ': {
                            'PATH':'/{loc}/Group%20B/HCB_Dental/Compliance-Popup_SiteArea/Popup_Content',
                            'CLOSE': false,
                            'REDIRECT': '/3M/cs_CZ/p/'
                        }
                    },
                    'URLs': [
                        'zdravotnicke-vyrobky',
                        'dentalni-a-ortodonticke-produkty',
                        'osobni-ochranne-prostredky/ochrana-dychacich-organu/masky-a-respiratory-pro-zdravotnictvi/i/bezpecnost',
                        'osobni-ochranne-prostredky/ochrana-dychacich-organu/filtracni-polomasky-pro-jednorazove-pouziti/i/bezpecnost',
                        'bezpecnost/ochrana-zdravi-a-bezpecnost-pri-praci/ochrana-dychacich-organu',
                        'osobni-ochranne-prostredky/ochrana-dychacich-organu/filtracni-polomasky-pro-jednorazove-pouziti/i/bezpecnost/ochrana-zdravi-a-bezpecnost-pri-praci/ochrana-dychacich-organu',
                        'osobni-ochranne-prostredky/ochrana-dychacich-organu/masky-a-respiratory-pro-zdravotnictvi',
                        'laboratorni-potreby-a-testovani/inkubatory-a-ohrivaci-bloky',
                        'laboratorni-potreby-a-testovani/luminometry',
                        'laboratorni-potreby-a-testovani/testy-a-indikatory/tampony-na-testy-atp'
                    ]
                }
            }

            this.campaign = this.getCampaign();
        	if (this.campaign) this.init();
        }

        /*  The Compliance Banner load rules contains default
            settings for the various "campaigns".  For example,
            "FUZE Health Care Compliance" campaign rules
            including:

                - Content item WCM path
                - Close button disabled
                - Redirect URL configuration
        */

        /*  This plugin will also look for page or site-level
            overrides.  An override should bein the following
            format:

            window.SETTINGS.COMPBANNER = {[options]}

            Where options can be the following properties:

            - NAME : Campaign name, should not contain any spaces or special characters, only used in the cookie name
            - PATH : WCM content path, replace locale with {loc} if the content is translated
            - CLOSE : boolean to indicate if there should or should not be a close link
            - REDIRECT : URL to redirect the user to in case of decline
            - EXPIRATION : Cookie expiration time in days, default to session cookie
            - BLUR : Adds a CSS blur effect to the main page content while the modal is open

            For example, here is an example override:

            SETTINGS.COMPBANNER = {NAME:'HC_POC',PATH':'/English/Group%20A/Corporate%20Content/ComplianceBanners/HealthCare_POC.html','CLOSE':'true','REDIRECT':'https://www.3m.com/us'};
        */

        /*  Locale-specific rules can now be defined by adding an
            object to the campaign called 'LOCALES' which will
            contain an object for each locale that will have
            specific settings.
        */

        // This plugin simply determines the current campaign for the compliance banner and returns the settings associated with that campaign
        ComplianceRules.prototype.init = function(){
            var defaultRules = {},
                localeRules = {},
                overrideRules = {};

            $debug('Compliance Campaign Name: ' + this.campaign, 'compBanner');

            // If there is a campaign name load rules
            if(this.campaign !== '' && !!this.campSettings[this.campaign]){
                // Look for defaults in the campSettings object
                defaultRules = this.getDefaults(this.campaign);
                $.extend(this.settings, defaultRules);

                // Look for locale-specific overrides
                localeRules = this.getLocaleRules(this.campaign);
                $.extend(this.settings, localeRules);

                // Look for overrides at site or page level configurations
                if(!!window.SETTINGS.COMPBANNER){
                    $debug('Compliance Override Settings found...', 'compBanner');
                    $debug(window.SETTINGS.COMPBANNER, 'compBanner');

                    $.extend(this.settings, window.SETTINGS.COMPBANNER);
                }

                $debug('Final Compliance Settings:', 'compBanner');
                $debug(this.settings, 'compBanner');

                return this.settings;
            } else{
                return;
            }
        }

        ComplianceRules.prototype.getCampaign = function(){
            var campID = false;
            // First check the SETTINGS object for site or page config campaigns
            if(!!window.SETTINGS.complianceCampaign){
                campID = window.SETTINGS.complianceCampaign;
            }

            // Product catalog-level campaigns take priority, check for id attribute first then meta with name attribute
            if($('#fuzeSpecialUsage').length > 0){
                campID = $('#fuzeSpecialUsage').attr('content');
            } else if($('meta[name="fuzeSpecialUsage"]').length > 0){
                campID = $('meta[name="fuzeSpecialUsage"]').attr('content');
            }

            // Check if a campaign matches the current URL
            for (var campaign in this.campSettings) {
                var thisCampaign = this.campSettings[campaign];

                if (thisCampaign.URLs) {
                    for (var i=0; i<thisCampaign.URLs.length; i++) {
                        if (location.pathname.indexOf(thisCampaign.URLs[i]) > -1) {
                            campID = campaign;
                        }
                    }
                }
            }

            return campID;
        }

        ComplianceRules.prototype.getDefaults = function(campID){
            var rules = {};

            if(!!this.campSettings[campID]){
                $debug('Compliance Campaign Settings found...', 'compBanner');
                $debug(this.campSettings[campID], 'compBanner');

                $.extend(rules, this.campSettings[campID]);
            }

            return rules;
        }

        ComplianceRules.prototype.getLocaleRules = function(campID){
            var rules = {};

            if(!!this.campSettings[campID].LOCALES){
                if(!!this.campSettings[campID].LOCALES[window.SETTINGS.LOCALE]){
                    $debug('Compliance Locale Settings found for: ' + window.SETTINGS.LOCALE, 'compBanner');
                    $debug(this.campSettings[campID].LOCALES[window.SETTINGS.LOCALE], 'compBanner');

                    $.extend(rules, this.campSettings[campID].LOCALES[window.SETTINGS.LOCALE]);
                }
            }

            return rules;
        }

        return ComplianceRules;
    });
}(MMMRequire));